import React from 'react';

const BYPASS_KEY = 'cap_bypass_maintenance';

// Expose bypass function on window for authorized testers.
// Open browser console and run: window.__capBypassMaintenance()
(window as any).__capBypassMaintenance = () => {
	sessionStorage.setItem(BYPASS_KEY, 'true');
	window.location.reload();
};

const MaintenanceOverlay: React.FC = () => {
	return (
		<>
			<style>{`
				@import url('https://fonts.googleapis.com/css2?family=Poppins:wght@300;400;500;600&display=swap');

				.maint-overlay {
					position: fixed;
					inset: 0;
					z-index: 9999;
					background: #f8f9f7;
					display: flex;
					flex-direction: column;
					align-items: center;
					justify-content: center;
					padding: 2rem;
					font-family: 'Poppins', sans-serif;
					font-size: 16px;
					color: #344735;
				}

				.maint-card {
					background: #ffffff;
					border-radius: 16px;
					border: 1px solid rgba(52, 71, 53, 0.12);
					padding: 3rem 3rem 2.5rem;
					width: 100%;
					max-width: 520px;
					text-align: center;
				}

				.maint-logo {
					height: 48px;
					width: auto;
					margin-bottom: 2.5rem;
					animation: maintFadeUp 0.5s ease 0.05s both;
				}

				.maint-divider {
					width: 48px;
					height: 3px;
					background: #344735;
					border-radius: 2px;
					margin: 0 auto 2rem;
					animation: maintFadeUp 0.5s ease 0.12s both;
				}

				.maint-heading {
					font-size: 24px;
					font-weight: 600;
					color: #344735;
					line-height: 1.3;
					margin-bottom: 1rem;
					animation: maintFadeUp 0.5s ease 0.2s both;
				}

				.maint-body {
					font-size: 15px;
					font-weight: 400;
					line-height: 1.7;
					color: #6b7280;
					margin-bottom: 2rem;
					animation: maintFadeUp 0.5s ease 0.28s both;
				}

				.maint-badge {
					display: inline-flex;
					align-items: center;
					gap: 8px;
					background: #eef2ee;
					border: 1px solid rgba(52, 71, 53, 0.18);
					border-radius: 100px;
					padding: 6px 16px;
					font-size: 13px;
					font-weight: 500;
					color: #344735;
					margin-bottom: 2.5rem;
					animation: maintFadeUp 0.5s ease 0.36s both;
				}

				.maint-badge::before {
					content: '';
					width: 7px;
					height: 7px;
					background: #344735;
					border-radius: 50%;
					animation: maintPulse 2s ease-in-out infinite;
					flex-shrink: 0;
				}

				.maint-contact {
					border-top: 1px solid rgba(52, 71, 53, 0.12);
					padding-top: 1.5rem;
					font-size: 13px;
					color: #6b7280;
					line-height: 1.6;
					animation: maintFadeUp 0.5s ease 0.44s both;
				}

				.maint-contact a {
					color: #344735;
					text-decoration: none;
					font-weight: 500;
					border-bottom: 1px solid rgba(52, 71, 53, 0.12);
					padding-bottom: 1px;
				}

				.maint-contact a:hover {
					border-bottom-color: #344735;
				}

				@keyframes maintPulse {
					0%, 100% { opacity: 1; transform: scale(1); }
					50% { opacity: 0.3; transform: scale(0.7); }
				}

				@keyframes maintFadeUp {
					from { opacity: 0; transform: translateY(10px); }
					to { opacity: 1; transform: translateY(0); }
				}
			`}</style>

			<div className="maint-overlay">
				<div className="maint-card">
					<img
						className="maint-logo"
						src="/assets/images/cap-logo-2.png"
						alt="CostAllocation Pro"
					/>
					<div className="maint-divider" />
					<h1 className="maint-heading">Scheduled Maintenance</h1>
					<p className="maint-body">
						We&apos;re performing scheduled maintenance to make CostAllocation Pro better than ever.
					</p>
					<div className="maint-badge">We&apos;ll be back shortly</div>
					<div className="maint-contact">
						Questions? Contact us at{' '}
						<a href="mailto:support@costallocationpro.com">
							support@costallocationpro.com
						</a>
					</div>
				</div>
			</div>
		</>
	);
};

export default MaintenanceOverlay;
